import { useToast } from "@chakra-ui/react";
import {
  ErrorToastHandler,
  SuccessToastHandler,
} from "components/helpers/ToastHelpers";
import _ from "lodash";
import moment from "moment";
import { useHistory } from "react-router-dom";

export const surveyId = ({
  surveysInfo,
  pathname,
}: {
  surveysInfo: any;
  pathname: string;
}): string => {
  const foundSurvey = findSurvey({ surveysInfo, pathname });
  if (foundSurvey?.length > 0) {
    // if (!(foundSurvey[0].isUnlocked as boolean)) history.replace("/");
    return foundSurvey[0].survey?.externalId as string;
  }
  return "";
};

export const findSurvey = ({
  surveysInfo,
  pathname,
}: {
  surveysInfo: any;
  pathname: string;
}): any[] => {
  // Normalize: handle both raw array and axios-wrapped response { data: [] }
  const surveyList: any[] = Array.isArray(surveysInfo)
    ? surveysInfo
    : Array.isArray(surveysInfo?.data)
    ? surveysInfo.data
    : [];

  const foundSurvey = surveyList.filter((el: any) => {
    const surveyName = el?.survey?.name.split(" ").join("-");

    return (
      surveyName.toUpperCase() ===
      pathname.split("/")[2]?.concat("-SURVEY")?.toUpperCase()
    );
  });

  return foundSurvey;
};

export const SaveSurveyToast = ({
  setAlertState,
  // setCompleted,
  isCompleted,
  toast,
  history,
  setSurveyCompleted,
}: {
  setAlertState: (arg: any) => void;
  // setCompleted: (arg: boolean) => void;
  isCompleted: boolean;
  toast: any;
  history: any;
  setSurveyCompleted?: any;
}): any => {
  return {
    onSuccess: () => {
      if (!isCompleted) {
        setAlertState({ isOpen: false });
        SuccessToastHandler({
          toast,
          title: "Survey saved successfully",
          description: "Your survey data has been saved successfully",
        });
        history.replace("/");
      } else setSurveyCompleted(true);
    },
    onError: (e: any) => {
      ErrorToastHandler({
        toast,
        title: e?.error ?? "Error",
        description: e?.message ?? "Some error occurred while saving survey",
      });
      setAlertState({ isOpen: false });
    },
  };
};

export const calculateUnlockedTime = (survey: any): string | number => {
  const unlockAt = new Date(survey?.unlockAt).getTime();
  const now = new Date().getTime();

  let diff: string | number = (unlockAt - now) / (1000 * 60 * 60 * 24);

  if (!isNaN(diff)) {
    if (diff < 1) {
      diff = (unlockAt - now) / (1000 * 60 * 60);
      diff =
        diff < 1
          ? `${Math.ceil(diff * 60)} minutes`
          : `${Math.ceil(diff)} hours`;
    } else {
      diff = Math.ceil(diff).toString().concat(" days");
    }
  }

  return diff;
  // return moment(unlockAt).fromNow();
};

/** shuffle the personality survey pages
 * @param pages ,
 * @returns Shuffled survey pages
 */

export const shuffleSurvey = (pages: any[], surveyPagesDict: any): any[] => {
  // get the indices from where the respective module starting
  let [eyetestIdx, ravensIdx, arithIdx, recallIdx, personalityIdx] = new Array(
    5
  ).fill(-1);

  for (let i = 0; i < pages.length - 1; i++) {
    const currentPage = pages[i]?.name;

    if ((currentPage.includes("eyestest") as boolean) && eyetestIdx < 0)
      eyetestIdx = i;
    else if ((currentPage.includes("ravens") as boolean) && ravensIdx < 0)
      ravensIdx = i;
    else if ((currentPage.includes("arith") as boolean) && arithIdx < 0)
      arithIdx = i;
    else if ((currentPage.includes("recall") as boolean) && recallIdx < 0)
      recallIdx = i;
    else if (
      (currentPage.includes("personality") as boolean) &&
      personalityIdx < 0
    )
      personalityIdx = i;
  }

  // extract and shuffled personality pages series
  const personalityArr = [
    pages[personalityIdx],
    ..._.shuffle(pages.slice((personalityIdx as number) + 1, pages.length - 3)),
  ];

  // get the respective modules, then shuffling begin
  const modulesArr = [
    // shuffle eyetest surveys
    [
      pages[eyetestIdx],
      ..._.shuffle(pages.slice((eyetestIdx as number) + 1, ravensIdx)),
    ],
    pages.slice(ravensIdx, arithIdx),
    pages.slice(arithIdx, recallIdx),
    pages.slice(recallIdx, personalityIdx),
    personalityArr,
  ];

  const finalShuffledArr = [
    ...pages.slice(0, eyetestIdx),
    ..._.shuffle(modulesArr).flat(),
    // ...personalityArr,
    ...pages.slice(pages.length - 3, pages.length),
  ];
  // console.log("shuffled arr", finalShuffledArr);

  // map page name to the respective index
  finalShuffledArr.forEach((page: any, idx: number) => {
    surveyPagesDict[page.name] = idx;
  });
  return finalShuffledArr;
};
